<!-- <li *ngIf="issketchuploaded">
      <label for="sketchImage">Plot Sketch:</label>
      </li> -->
      <div class="fieldcontainer">
        <!-- <li> <label for="sketchImage">Upload</label></li> -->
        <li>
          <ng-container *ngIf="!issketchuploaded && type=='both'">
            <div style="display: flex; width: 100%; gap: 12px">
              <label for="uploaddoctype" class="required question">Type:</label>
      
              <div class="select" style="margin: -2px">
                <mat-select
                  matNativeControl
                  required
                  name="uploaddoctype"
                  placeholder="Select type"
                  [(ngModel)]="filetypeselected"
                  [disabled]="issketchuploaded || selecttypedisabled"
                  [required]="true"
                  (selectionChange)="onSelectingfiletype($event)"
                  style="
                    display: flex;
                    align-items: center;
                    border: 1px solid #f0f0f0;
                    background: #fbfbfb;
                    height: 26px;
                    padding: 5px;
                    width: 100%;
                  "
                >
                  <mat-option value="image/*" style="color: #5d5d5d"
                    >Image</mat-option
                  >
                  <mat-option value="PDF" style="color: #5d5d5d">PDF</mat-option>
                </mat-select>
              </div>
            </div>
          </ng-container>
        </li>
        <!-- before sketchuploadedview -->
        <li>
          <div class="bodycontainer1" *ngIf="!issketchuploaded">
            <div
              class="dropzone"
              appDnd
              style="position: relative; gap: 8px"
              (click)="fileInput.click()"
            >
              <form #reqform="ngForm">
                <input
                  type="file"
                  #fileInput
                  [accept]="filetype"
                  name="fileInput"
                  id="fileInput"
                  required="true"
                  [multiple]="ismultiple"
                  (change)="fileBrowseHandler($event.target)"
                />
              </form>
              <img
              *ngIf="type=='pdf'"
              src="../../../assets/appelements/pdfplaceholder.png"

                alt="dropfilebox"
                style="width: 58px;height: 58px;"
              />
              <!-- <img
              *ngIf="type=='image'"
              src="../../../assets/appelements/dropfileboximg.svg"

              alt="dropfilebox"
              class="dragdropimage"
           
            /> -->
            <img
            *ngIf="type=='dwg'"
            src="../../../assets/Griha Mantra Icons/planai/DWG-Placeholder.png"

              alt="dropfilebox"
              style="width: 30px;
    height: 31px;"
            />


            <mat-icon  class="dragdropimage" *ngIf="type=='image'">add_photo_alternate</mat-icon>
      
              <p class="dragdroptext" style="margin-left: 0%">
                <span style="border-bottom: 2px solid transparent"> </span>
                <span
                  style="
                    background-color: transparent;
                    color: black;
                    width: fit-content;
                    padding: 0;
                    height: fit-content;
                    border-bottom: 2px solid #778657;
                    border-radius: 0;
                  "
                  >Browse
                </span>
              </p>
              <p
                *ngIf="filetype == 'image/*' && from == 'multiple'"
                class="dragdroptext"
                style="
                  margin-left: 2%;
                  bottom: 20px;
                  font-size: 12px;
                  color: #a2a2a2;
                "
              >
                Can upload only 5 images.
              </p>
              <p
              *ngIf="filetype == '.pdf' && from == 'multiple'"
              class="dragdroptext"
              style="
                margin-left: 2%;
                bottom: 11px;
                font-size: 12px;
                color: #a2a2a2;
              "
            >
              Can upload only five pdf.
            </p>
            </div>
            <!-- <mat-error *ngIf="sketchuploaderror">
                  Please upload company logo
                </mat-error> -->
          </div>
      
          <!-- after sketchuploadedview -->
      
          <div
            class="bodycontainer2"
            *ngIf="issketchuploaded"
            style="
              background-color: #f4f4f4;
              text-align: center;
              border: dashed 1.5px #b4b4b4;
              border-radius: 5px;
              margin-top: 10px;
              /* height: 300px; */
            "
          >
            <!-- <div *ngIf="!isloadingcomplete" class="loadercontainer">
              <span class="loader"></span>
            </div> -->
            <div
              style="
                padding: 20px;
                /* height: calc(100vh - 128px); */
                overflow-y: auto;
              "
            >
              <div class="filesection">
                <div
                  class="singlefile"
                  *ngFor="let item of filelinkarray; let i = index"
                >
                  <!-- <button class="thumbnailclose">
                      <mat-icon class="thumbnailcloseicon"
                        (click)="deletesketchupload($event, i)">close</mat-icon>
                    </button> -->
                  <button class="thumbnailclose" style="background: none">
                    <mat-icon (click)="editsketchupload($event, i)">close</mat-icon>
                  </button>
      
                  <div *ngIf="!isloadingcomplete" class="loadercontainer">
                    <span class="loader"></span>
                  </div>
                  <img *ngIf="!pdfupload && type=='image'" class="uploadedimage" [src]="item" alt="" />
                  <img *ngIf="dwgupload && type=='dwg'" class="uploadedimage" src="../../../assets/Griha Mantra Icons/planai/DWG-Placeholder.png"
                  alt="" />

                  <img
                  *ngIf="type=='pdf'"
                    class="uploadedimage"
                    src="../../../assets/appelements/pdfplaceholder.png"


                    alt=""
                  />
                
                  
                </div>
      
                <div
                  class="singlefile"
                 *ngIf="filelinkarray.length==0"
                >
                  <!-- <button class="thumbnailclose">
                      <mat-icon class="thumbnailcloseicon"
                        (click)="deletesketchupload($event, i)">close</mat-icon>
                    </button> -->
                
      
                  <div *ngIf="!isloadingcomplete" class="loadercontainer">
                    <span class="loader"></span>
                  </div>
                  <img *ngIf="dwgupload && type=='dwg'" class="uploadedimage" src="../../../assets/Griha Mantra Icons/planai/DWG-Placeholder.png"
                  alt="" />

                  <img *ngIf="!pdfupload && type=='image'" class="uploadedimage"   src="../../../assets/draganddrop.png" alt="" />
                  <img
                  *ngIf="type=='pdf'"
                    class="uploadedimage"
                    src="../../../assets/appelements/pdfplaceholder.png"

                    alt=""
                  />
                
                  
                </div>
      
      
      
                <div style="margin-top: 2%" 
                *ngIf="filetype=='image/*'"
                >
                  <label
                    style="
                      color: #125e91;
                      background-color: #f4f4f4;
                      border-radius: 3.5px;
                      padding: 8px 16px;
                      display: flex;
                      align-items: center;
                      text-align: center;
                      justify-content: center;
                    "
                    for="fileInput"
                  >
                    <!-- <mat-icon
                      *ngIf="filelinkarray && filelinkarray.length !== 5"
                      [ngStyle]="!ismultiple ? { display: 'none' } : {}"
                    (click)="fileBrowseHandler($event.target)"

                      >add_photo_alternate</mat-icon
                    > -->
                  </label>
      
      
                  
                  <input
                  *ngIf="filetype=='image/*'"
                  type="file"
                  #fileInput
                  [accept]="filetype"
                  name="fileInput"
                  id="fileInput"
                  required="true"
                  [multiple]="ismultiple"
                  (change)="fileBrowseHandler($event.target)"
                />
             
                </div>
      
                <div style="margin-top: 2%" 
                *ngIf="filetype=='.pdf'"
                >
                  <label
                    style="
                      color: #125e91;
                      background-color: #f4f4f4;
                      border-radius: 3.5px;
                      padding: 8px 16px;
                      display: flex;
                      align-items: center;
                      text-align: center;
                      justify-content: center;
                    "
                    for="fileinput"
                  >
                    <mat-icon
                      *ngIf="filelinkarray && filelinkarray.length !== 5"
                      [ngStyle]="!ismultiple ? { display: 'none' } : {}"
                      >add_photo_alternate</mat-icon
                    >
                  </label>
      
      
                  <input
                  *ngIf="filetype=='.pdf'"
                  type="file"
                  #fileInput
                  [accept]="filetype"
                  name="fileinput"
                  id="fileinput"
                  required="true"
                  [multiple]="ismultiple"
                  (change)="fileBrowseHandler($event.target)"
                />
             
                </div>
      
      
              
      
      
              </div>
            </div>
          </div>
        </li>
      </div>
      